import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/git-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M100.6 334.2c48.6 3.3 59 2.1 59 11.9 0 20-65.5 20.1-65.5 1.5 0-5.1 3.3-9.4 6.6-13.5zM128.5 217.6c31 0 31.8 44.5-0.8 44.5-33 0-31.5-44.5 0.8-44.5zM448 80v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM221 149.3c0 14.5 8.4 22.9 22.9 22.9 14.7 0 23.1-8.4 23.1-22.9 0-14.5-8.4-22.3-23.1-22.3-14.5 0-22.9 7.8-22.9 22.3zM199.2 195h-49.5c-25-6.5-81.6-4.8-81.6 46.8 0 18.8 9.4 32 21.8 38.1-15.7 14.4-23.1 21.1-23.1 30.7 0 6.9 2.8 13.2 11.2 16.8-8.9 8.4-14 14.5-14 25.9 0 20.1 17.5 31.7 63.5 31.7 44.2 0 69.9-16.5 69.9-45.7 0-36.7-28.2-35.3-94.8-39.4l8.4-13.4c17 4.7 74.2 6.2 74.2-42.4 0-11.7-4.8-19.8-9.4-25.7l23.4-1.8zM283.5 304.8l-13-1.8c-3.8-0.5-4.1-1-4.1-5.1v-105.5h-52.6l-2.8 20.6c15.8 5.5 17 4.9 17 10.2v74.7c0 5.6-0.3 4.6-17 6.9v20.1h72.4zM384 315l-6.9-22.4c-40.9 15.4-37.8-12.4-37.8-16.7v-60.7h37.8v-25.4h-35.8c-2.9 0-2 2.5-2-38.6h-24.2c-2.8 27.7-11.7 38.9-34 41.4v22.6c20.5 0 19.8-0.8 19.8 2.5v66.6c0 28.7 11.4 40.9 41.7 40.9 14.5 0 30.5-4.8 41.4-10.2z'
      }
    ]
  }
})
